import { TMap } from '@client/new/helpers/types';
import { WorkoutStatus } from './workouts/workouts.domain';
import { StatusTagProps } from '@client/new/components/StatusTag/StatusTag';
import {
  GetCollectionPageDataQuery,
  WorkoutTiny as GqlWorkoutTiny,
} from 'generated/graphql';
import { LiteProgramType } from './mappers';

export type WorkoutTiny = Pick<
  GqlWorkoutTiny,
  | 'id'
  | 'statsRatingAverage'
  | 'statsComments'
  | 'statsBegins'
  | 'statsCompletions'
>;

export type LiteProgram = {
  programId: number;
  programType: SalesType;
  categoryType: LiteProgramType;
  workouts: WorkoutTiny[];
  salesPageUrl: string;
  hasSalesPageConfig: boolean;
  price: string;
  discountedPrice: string | null;
  tags: Array<StatusTagProps>;
  programState: 'not-publish-ready' | 'publish-ready' | 'published';
  title: string;
  subtitle: string;
  thumbnailUrl: string;
  index?: number;
  deeplinkUrl?: string;
  accessType: string;
  migrationBundleId: number | null;
};

export const salesTypeValues = ['otp', 'subscription'] as const;
export type SalesType = (typeof salesTypeValues)[number];

export const discountTypeValues = ['Percentage', 'FixedAmount'] as const;
export type DiscountType = (typeof discountTypeValues)[number];

export const subscriptionTypeValues = ['annual', 'monthly'] as const;
export type SubscriptionType = (typeof subscriptionTypeValues)[number];

export type WorkoutsTabHash = `workouts-${WorkoutStatus}`;

export type ProgramTabHash =
  | WorkoutsTabHash
  | 'about'
  | 'pricing'
  | 'sales-page'
  | 'challenges'
  | 'pricing-packages';

export const allTabs: TMap<ProgramTabHash, string> = {
  'workouts-published': 'Workouts',
  'workouts-draft': 'Workouts',
  'workouts-archived': 'Workouts',
  'workouts-scheduled': 'Workouts',
  challenges: 'Challenges',
  about: 'About',
  pricing: 'Price',
  'pricing-packages': 'Price & package',
  'sales-page': 'Landing Page',
};

export const workoutTabToType: TMap<WorkoutsTabHash, WorkoutStatus> = {
  'workouts-published': 'published',
  'workouts-draft': 'draft',
  'workouts-archived': 'archived',
  'workouts-scheduled': 'scheduled',
};

export const workoutTypeToTab: TMap<WorkoutStatus, WorkoutsTabHash> = {
  published: 'workouts-published',
  draft: 'workouts-draft',
  archived: 'workouts-archived',
  scheduled: 'workouts-scheduled',
};

export type RawCollection = GetCollectionPageDataQuery['collection'];

export type Price = {
  price: number;
  playbookFee?: number;
  discountedPrice?: number;
  discountPercent?: number;
};
